<template>
  <div class="app-container">
    <!-- <el-button type="info" circle icon="el-icon-refresh"  style="font-size: 14px;cursor: pointer;float: right;" @click="fetchData()"></el-button> -->
    <!-- <el-select
      filterable
      v-model="screen.park_id"
      placeholder="请选择园区"
      :disabled="userInfo.park_id != 0"
      class="screenInput"
      @change="parkChange"
    >
      <el-option label="全部" value="0"></el-option>
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in parkList"
        :key="index"
      ></el-option>
    </el-select> -->
    <el-select
      filterable
      v-model="screen.company_id"
      placeholder="请选择企业"
      :disabled="userInfo.type == 2"
      class="screenInput"
      v-if="userInfo.type != 2"
    >
      <el-option label="全部" value="0"></el-option>
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in companyList"
        :key="index"
      ></el-option>
    </el-select>
    <!-- <el-input
      class="screenInput"
      v-model="screen.phone"
      placeholder="业主手机号"
    ></el-input> -->
    <el-input
      class="screenInput"
      v-model="screen.visitor_name"
      placeholder="来访人姓名"
    ></el-input>
    <el-input
      class="screenInput"
      v-model="screen.visitor_phone"
      placeholder="来访人手机号"
      maxlength="11"
    ></el-input>
    <div class="btn">
      <el-button
        type="primary"
        @click="(screen.page = 1), fetchData()"
        style="margin-bottom: 5px; margin-left: 5px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        plain
        @click="reset()"
        style="margin-bottom: 5px; margin-left: 5px"
        >重置</el-button
      >
    </div>
    <div>
      <el-button
        size="medium"
        type="warning"
        @click="derive()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/caller/export')"
        >导出</el-button
      >
    </div>
    <el-table
      max-height="700"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column label="序号" width="100">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="园区">
        <template slot-scope="scope">
          <span v-if="scope.row.park">{{ scope.row.park.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="受访公司">
        <template slot-scope="scope">
          <span v-if="scope.row.company">{{ scope.row.company.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="来访人姓名">
        <template slot-scope="scope">
          {{ scope.row.visitor_name }}
        </template>
      </el-table-column>
      <el-table-column label="来访人手机号">
        <template slot-scope="scope">
          {{ scope.row.visitor_phone }}
        </template>
      </el-table-column>
      <el-table-column label="访问开始时间">
        <template slot-scope="scope">
          {{ scope.row.start_time }}
        </template>
      </el-table-column>
      <el-table-column label="访问结束时间">
        <template slot-scope="scope">
          {{ scope.row.end_time }}
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 1">待审核</el-tag>
          <el-tag type="success" v-if="scope.row.status == 2">已通过</el-tag>
          <el-popover
            v-if="scope.row.status == 3"
            placement="top-start"
            width="200"
            trigger="hover"
            :content="scope.row.reason"
          >
            <el-tag type="danger" slot="reference">
              已拒绝
              <i class="el-icon-question"></i>
            </el-tag>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150px" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="audit(scope.row.id)"
            v-if="roles.includes('/caller/up_status') && scope.row.status == 1"
            >审核</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="cancelYy(scope.row.id)"
            style="margin-left: 0; margin-top: 5px"
            v-if="roles.includes('/caller/cancel')  && scope.row.visit_status != 9"
            >取消预约</el-button
          >
          <!-- <el-button
            size="mini"
            type="success"
            style="margin-left: 0; margin-top: 5px"
            @click="seeRecord(scope.row.id)"
            v-if="roles.includes('/caller/car_lists') && scope.row.status == 2"
            >查看通行记录</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-dialog title="审核" :visible.sync="dialogVisible" width="30%">
      <el-form
        :model="visitorForm"
        :rules="rules"
        ref="visitorForm"
        label-width="100px"
      >
        <el-form-item label="是否通过" prop="status">
          <el-select
            filterable
            v-model="visitorForm.status"
            style="width: 80%"
            placeholder="请选择"
          >
            <el-option label="通过" value="2"></el-option>
            <el-option label="拒绝" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="拒绝原因"
          prop="reason"
          v-if="visitorForm.status == 3"
        >
          <el-input
            :rows="3"
            style="width: 80%"
            type="textarea"
            v-model="visitorForm.reason"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="通行记录" :visible.sync="carVisible">
      <el-table :data="carList">
        <el-table-column align="center" label="序号" width="95">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="所属园区">
          <template slot-scope="scope">
            <span v-if="scope.row.park">{{ scope.row.park.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="指令集设备名称">
          <template slot-scope="scope">
            <span>{{ scope.row.device_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="开门类型">
          <template slot-scope="scope">
            <span v-if="scope.row.open_type == 0">未知</span>
            <span v-if="scope.row.open_type == 1">刷卡开门</span>
            <span v-if="scope.row.open_type == 2">按钮开门</span>
            <span v-if="scope.row.open_type == 3">远程开门</span>
            <span v-if="scope.row.open_type == 8">公共密码开门</span>
            <span v-if="scope.row.open_type == 12">个人密码开门</span>
            <span v-if="scope.row.open_type == 16">无效开门(无权限)</span>
            <span v-if="scope.row.open_type == 98">蓝牙开门</span>
            <span v-if="scope.row.open_type == 99">APP开门</span>
            <span v-if="scope.row.open_type == 103">二维码开门</span>
            <span v-if="scope.row.open_type == 104">人脸识别开门</span>
          </template>
        </el-table-column>
        <el-table-column label="门禁抓拍图片">
          <template slot-scope="scope">
            <span v-if="scope.row.picture_url">
              <el-image
                style="width: 170px; height: 100px; margin: 0 5px 5px 0"
                :src="imageOss + scope.row.picture_url"
                fit="contain"
                :preview-src-list="
                  $pathDispose(scope.row.picture_url.split(','))
                "
              >
              </el-image>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="carVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  callerLists,
  callerUpStatus,
  callerCarLists,
  openPark,
  openCompany,
  callerExport,
  cancelCaller,
} from "@/api/index";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      list: [],
      listLoading: true,
      dialogVisible: false,
      visitorForm: {
        id: "",
        status: "2",
        reason: "",
      },
      rules: {
        status: [
          { required: true, message: "请选择是否通过", trigger: "blur" },
        ],
        reason: [
          { required: true, message: "请输入拒绝原因", trigger: "blur" },
        ],
      },
      screen: {
        page: 1,
        page_size: 15,
        phone: "",
        visitor_name: "",
        visitor_phone: "",
        park_id: "",
        company_id: "",
      },
      total: 0,
      parkList: [],
      companyList: [],
      carList: [],
      carVisible: false,
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
      if (this.userInfo.type == 2) {
        this.screen.company_id = this.userInfo.company_id;
      }
      this.getCompany(this.userInfo.park_id);
    } else {
      this.screen.park_id = "";
    }

//  if (this.userInfo.is_super != 1) {
//       if (this.userInfo.type == 1) {
//         this.screen.park_id = this.userInfo.park_id;
//         this.screenPark(this.userInfo.park_id);
//       } else if (this.userInfo.type == 2) {
//         this.screen.park_id = this.userInfo.park_id
//         this.screen.company_id = this.userInfo.company_id;
//       }
//     }

    this.fetchData();
    this.getPark();
  },
  methods: {
    cancelYy(e) {
      var that = this;
      this.$confirm("是否取消预约?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {

          cancelCaller({ id: e }).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.fetchData();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 导出
    derive() {
      let data = {
        company_id: this.screen.company_id,
        park_id: this.screen.park_id,
        visitor_name: this.screen.visitor_name,
        visitor_phone: this.screen.visitor_phone,
      };
      const loading = this.$loading({
        lock: true,
        text: "数据量过大，正在导出中...",
        spinner: "el-icon-loading",
      });
      callerExport(data)
        .then((res) => {
          loading.close();
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel;charset=utf-8",
          });
          let downloadElement = document.createElement("a");
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = res.name;
          // downloadElement.target="_blank"
          downloadElement.setAttribute("target", "_blank");
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((error) => {
          loading.close();
        });
    },

    // 查看通行记录
    seeRecord(id) {
      callerCarLists({ id: id }).then((res) => {
        console.log(id);
        this.carList = res.data.data;
        this.carVisible = true;
      });
    },
    // 选中园区
    parkChange(e) {
      this.screen.company_id = "";
      this.getCompany(e);
    },
    // 获取企业
    getCompany(parkId = "") {
      openCompany({ park_id: parkId, is_page: 2 }).then((response) => {
        this.companyList = response.data.lists;
      });
    },
    audit(id) {
      this.dialogVisible = true;
      this.visitorForm.id = id;
      this.$nextTick(() => {
        this.$refs.visitorForm.resetFields();
      });
    },
    reset() {
      this.screen = {
        phone: "",
        visitor_name: "",
        visitor_phone: "",
        park_id: "",
        company_id: "",
        page: 1,
        page_size: 15,
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
        if (this.userInfo.type == 2) {
          this.screen.company_id = this.userInfo.company_id;
        }
        this.getCompany(this.userInfo.park_id);
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    submitForm() {
      var that = this;
      this.$refs.visitorForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              callerUpStatus(that.visitorForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  this.$refs.visitorForm.resetFields();
                  that.dialogVisible = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    fetchData() {
      this.listLoading = true;
      callerLists(this.screen).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.btn {
  display: inline-block;
}
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploader {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px 5px 0;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
</style>
